import React from 'react';
import BackButton from '../component/BackButton';

function Error() {
  return (
    <div className="page error">
      <BackButton />
      <div className="contents">
        <h1 className="error">404 Not Found</h1>
      </div>
    </div>
  );
}

export default Error;
